"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationRole = exports.OrgRoleType = void 0;
const firebase_1 = require("../../bindings/firebase");
var OrgRoleType;
(function (OrgRoleType) {
    OrgRoleType[OrgRoleType["board"] = 0] = "board";
    OrgRoleType[OrgRoleType["other"] = 1] = "other";
})(OrgRoleType = exports.OrgRoleType || (exports.OrgRoleType = {}));
class OrganizationRole {
    constructor(role) {
        var _a, _b;
        this._members = [];
        this._new_members = [];
        this.active = (_a = role.active) !== null && _a !== void 0 ? _a : true;
        this.created = role.created;
        this.altered = role.altered;
        this.description = role.description;
        this.name = role.name;
        this.permissions = role.permissions;
        this.members = role.members;
        this.new_members = role.new_members;
        this.room = role.room;
        this.pri = role.pri;
        this.type = role.type;
        this.verv_type = role.verv_type;
        this.hidden = (_b = role.hidden) !== null && _b !== void 0 ? _b : false;
    }
    static new(data) {
        const roleData = {
            altered: firebase_1.firebase.firestore.Timestamp.now(),
            created: firebase_1.firebase.firestore.Timestamp.now(),
            description: '',
            name: '',
            permissions: [],
            pri: 0,
            type: OrgRoleType.board,
            hidden: false,
            active: true,
            verv_type: 0
        };
        if (data) {
            Object.keys(data).forEach((key) => {
                // already have checks that key is in both
                roleData[key] = data[key];
            });
        }
        return new this(roleData);
    }
    static fromQueryDocumentSnapshot(snapshot, organizationPersons) {
        if (!snapshot.exists) {
            return undefined;
        }
        const role = this.new(snapshot.data());
        role._querySnap = snapshot;
        role._ref = snapshot.ref;
        role._parentId = snapshot.ref.parent.parent.id;
        if (organizationPersons) {
            role._members = (role.members || []).map((roleMember) => organizationPersons.find((person) => person.ref().isEqual(roleMember)));
            role._new_members = (role.new_members || []).map((roleMember) => organizationPersons.find((person) => person.ref().isEqual(roleMember)));
        }
        return role;
    }
    static fromQuerySnapshot(snapshot, organizationPersons) {
        const roles = [];
        if (snapshot.empty) {
            return roles;
        }
        for (const d of snapshot.docs) {
            const role = this.fromQueryDocumentSnapshot(d, organizationPersons);
            if (role) {
                roles.push(role);
            }
        }
        return roles;
    }
    getRaw() {
        const rawData = { ...this };
        Object.keys(rawData).forEach((key) => {
            if (key.startsWith('_')) {
                delete rawData[key];
            }
        });
        return rawData;
    }
    querySnap() {
        if (!this._querySnap) {
            throw new Error('Somehow querysnap does not exist! role');
        }
        return this._querySnap;
    }
    ref() {
        if (!this._ref) {
            throw new Error('Somehow ref does not exist! role');
        }
        return this._ref;
    }
    getId() {
        const qs = this.querySnap();
        if (!qs) {
            throw new Error('Somehow id does not exist! role');
        }
        return qs.id;
    }
    parentID() {
        if (!this._parentId) {
            throw new Error('Somehow parentid does not exist! role');
        }
        return this._parentId;
    }
    set memberPersons(members) {
        this._members = members;
    }
    set newMemberPersons(members) {
        this._new_members = members;
    }
    get memberPersons() {
        return this._members;
    }
    get newMemberPersons() {
        return this._new_members;
    }
}
exports.OrganizationRole = OrganizationRole;
//# sourceMappingURL=role.js.map